import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './main.scss';

const Main = ({ children, className }) => {
  return (
    <main className={classnames(styles.main, className)}>
      {children}
    </main>
  );
};

Main.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export { Main };



// WEBPACK FOOTER //
// ./src/components/main/main.js